import { render } from "./one-request-details.vue?vue&type=template&id=eb2ca7b0&scoped=true"
import script from "./one-request-details.vue?vue&type=script&lang=js"
export * from "./one-request-details.vue?vue&type=script&lang=js"

import "./one-request-details.vue?vue&type=style&index=0&id=eb2ca7b0&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb2ca7b0"]])

export default __exports__